import { render } from "./QuestionDescription.vue?vue&type=template&id=28fa7a88"
import script from "./QuestionDescription.vue?vue&type=script&lang=js"
export * from "./QuestionDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__